const EGDSToolbarNavigationTypeIconsMap = [['close', 'close'], ['back', 'arrow_back'], ['expand_up', 'expand_less'], ['expand_down', 'expand_more']];
const EGDSToolbarNavigationTypeIcons = new Map(EGDSToolbarNavigationTypeIconsMap);
const EGDSToolbarPageMarginsMap = [['small', '--spacing__2x'], ['large', '--spacing__8x']];
const EGDSToolbarPageMargins = new Map(EGDSToolbarPageMarginsMap);
export { EGDSToolbarNavigationTypeIcons, EGDSToolbarPageMargins };